module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/selfi1__20dc63b8277d9e0befa34d70617844bb.png";